export default __webpack_public_path__ + "assets/models/31098aa6c8a9cb843c108bfcc38fedc5.glb";